// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetOfferCollectionResponse

export type WidgetOfferCollectionApiResponse = {
	id: string;
	name: string;
	sortOrder: number;
	activityIds: Array<string>;
	offerIds: Array<string>;
	image: string | null;
	description: string | null;
};

export type WidgetOfferCollection = {
	id: string;
	name: string;
	sortOrder: number;
	activityIds: Array<string>;
	offerIds: Array<string>;
	image: string | null;
	description: string | null;
};

export function hydrateWidgetOfferCollection(data: WidgetOfferCollectionApiResponse): WidgetOfferCollection {
	return { ...data };
}